module.exports = __webpack_public_path__ + "img/pu.c0c57c2f.png";